import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#06101E] text-white">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        {/* Brand */}
        <div className="lg:col-span-1">
          <div className="mb-5">
            <img
              src="https://storage.readdy-site.link/project_files/3f4e5315-53a9-4781-b608-6e8efdbbbb26/c07fec73-4b7a-4c2e-8c3b-6c3e96222cb6_ACE-DIVING-MIAMI-PADI-SSI-SDI-TDI-ERDI-DIVE-CENTER-NEAR-ME.jpg?v=dfaed86c0c2a04c7a5c8aa26d1b83447"
              alt="Ace Diving Miami — PADI SSI SDI TDI ERDI Dive Center"
              className="h-14 w-auto object-contain"
            />
          </div>
          <p className="text-white/45 text-sm leading-relaxed mb-5">
            Miami&apos;s premier waterfront dive center. Professional scuba training, guided dives, and certification programs from Pier 5, Biscayne Blvd.
          </p>

          {/* Accreditations */}
          <div className="flex flex-wrap gap-1.5 mb-6">
            {['PADI', 'SSI', 'SDI', 'TDI', 'ERDI'].map((ag) => (
              <span
                key={ag}
                className="bg-white/8 border border-white/12 text-white/60 text-[10px] font-bold px-2.5 py-1 rounded-md tracking-wider"
              >
                {ag}
              </span>
            ))}
          </div>

          <div className="flex items-center gap-3">
            {[
              { icon: 'ri-facebook-fill', href: '#' },
              { icon: 'ri-instagram-line', href: '#' },
              { icon: 'ri-youtube-line', href: '#' },
            ].map(({ icon, href }) => (
              <a
                key={icon}
                href={href}
                rel="nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-white/8 hover:bg-[#00B4D8] transition-colors cursor-pointer"
              >
                <i className={`${icon} text-base`} />
              </a>
            ))}
          </div>
        </div>

        {/* Services */}
        <div>
          <h4 className="text-white font-semibold text-[11px] uppercase tracking-widest mb-5">
            Programs
          </h4>
          <ul className="space-y-3">
            {[
              'Open Water Certification',
              'Advanced Open Water',
              'Rescue Diver Course',
              'Divemaster Program',
              'Technical & TDI Diving',
              'Specialty Certifications',
              'Equipment Rental',
            ].map((item) => (
              <li key={item}>
                <Link
                  to="/services"
                  className="text-white/45 hover:text-[#00B4D8] text-[13px] transition-colors cursor-pointer"
                >
                  {item}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Company */}
        <div>
          <h4 className="text-white font-semibold text-[11px] uppercase tracking-widest mb-5">
            Company
          </h4>
          <ul className="space-y-3">
            {[
              { label: 'About Ace Diving', href: '/about' },
              { label: 'Our Services', href: '/services' },
              { label: 'Diving in Miami', href: '/miami' },
              { label: 'Our Process', href: '/#process' },
              { label: 'Testimonials', href: '/#testimonials' },
              { label: 'FAQ', href: '/#faq' },
              { label: 'Contact', href: '/#contact' },
            ].map((item) => (
              <li key={item.label}>
                <Link
                  to={item.href}
                  className="text-white/45 hover:text-[#00B4D8] text-[13px] transition-colors cursor-pointer"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-white font-semibold text-[11px] uppercase tracking-widest mb-5">
            Contact
          </h4>
          <ul className="space-y-4">
            <li className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                <i className="ri-map-pin-line text-[#00B4D8] text-base" />
              </div>
              <span className="text-white/45 text-sm leading-relaxed">
                401 Biscayne Blvd<br />
                Pier 5, Slip 33<br />
                Miami, FL 33132
              </span>
            </li>
            <li className="flex items-center gap-3">
              <div className="w-5 h-5 flex items-center justify-center shrink-0">
                <i className="ri-phone-line text-[#00B4D8] text-base" />
              </div>
              <a
                href="tel:+17862413194"
                className="text-white/45 hover:text-[#00B4D8] text-sm transition-colors cursor-pointer"
              >
                +1 786-241-3194
              </a>
            </li>
            <li className="flex items-center gap-3">
              <div className="w-5 h-5 flex items-center justify-center shrink-0">
                <i className="ri-whatsapp-line text-[#00B4D8] text-base" />
              </div>
              <a
                href="https://wa.me/17862413194"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="text-white/45 hover:text-[#00B4D8] text-sm transition-colors cursor-pointer"
              >
                WhatsApp Us
              </a>
            </li>
            <li className="flex items-center gap-3">
              <div className="w-5 h-5 flex items-center justify-center shrink-0">
                <i className="ri-mail-line text-[#00B4D8] text-base" />
              </div>
              <a
                href="mailto:info@ace-diving.com"
                className="text-white/45 hover:text-[#00B4D8] text-sm transition-colors cursor-pointer"
              >
                info@ace-diving.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/8">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/25 text-xs text-center sm:text-left">
            &copy; {new Date().getFullYear()} Ace Diving Miami. All rights reserved. PADI · SSI · SDI · TDI · ERDI Certified Dive Center.
          </p>
          <div className="flex items-center gap-5">
            {['Privacy Policy', 'Terms of Service'].map((item) => (
              <a
                key={item}
                href="#"
                rel="nofollow"
                className="text-white/25 hover:text-white/55 text-xs transition-colors cursor-pointer"
              >
                {item}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
